import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

function ViewProject() {
  return (
    <>
      <Section>
        <Container>
          <>
            <PWrapper>
              <P
                key="there"
                initial={{ y: "0px" }}
                whileInView={{ x: "20px" }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                INTERESTED IN WORKING TOGETHER?
              </P>
            </PWrapper>
            <Head>
              <RevealBar
                key="black"
                initial={{
                  width: "0%",
                  height: "100%",
                  position: "absolute",
                }}
                whileInView={{ width: "100%", transform: "translateX(100%)" }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
              />
              <H2
                initial={{ y: "50px" }}
                whileInView={{ y: "0px" }}
                transition={{ duration: 0.5, delay: 0.3 }}
              >
                <a
                  href="mailto:savadn632@gmail.com"
                  style={{ color: "var(--text)", textDecoration: "none" }}
                >
                  savadn632@gmail.com
                </a>
              </H2>
            </Head>
          </>
        </Container>
      </Section>
    </>
  );
}

export default ViewProject;

const Section = styled.div`
  height: 420px;
  background-color: var(--bg);
  color: var(--text);
  display: flex;
  align-items: center;
  justify-content: start;
  border-top: 1px solid var(--border);
  transition: background-color 0.3s ease, color 0.3s ease;

  @media (max-width: 768px) {
    height: auto;
    padding: 60px 0;
  }
`;

const Container = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: auto;
  padding: 0 20px;

  @media (max-width: 1430px) {
    padding: 0 30px;
  }
`;

const Head = styled.h1`
  overflow: hidden;
  position: relative;
  width: fit-content;
  font-size: 40px;
  line-height: 50px;
  margin-bottom: 10px;
`;

const H2 = styled(motion.h2)`
  font-size: 36px;
  font-weight: 400;
  letter-spacing: -0.5px;
  transition: 0.5s ease;
  &:hover {
    margin-left: 15px;
  }

  @media (max-width: 768px) {
    font-size: 22px;
    letter-spacing: -0.3px;
  }
`;

const PWrapper = styled.div`
  overflow: hidden;
  margin-top: 80px;

  @media (max-width: 768px) {
    margin-top: 50px;
  }
`;

const P = styled(motion.p)`
  width: fit-content;
  font-size: 11px;
  line-height: 20px;
  margin-bottom: 16px;
  color: var(--text-5);
  letter-spacing: 2px;
  font-weight: 500;

  @media (max-width: 768px) {
    width: 100%;
    letter-spacing: 1.5px;
  }
`;

const RevealBar = styled(motion.div)`
  background: var(--overlay);
  transition: background 0.3s ease;
`;
